import React from "react";
import { useManagerTrial } from "../../context/contextManagerTrial";



const TermUpgrade = () => {
  const { currentCardUpgrade } = useManagerTrial();
  return (
    <>
      <div className="terms-container">
        <div className="terms-wrapper">
          <div className="term-container">
            <div
              dangerouslySetInnerHTML={{
                __html: currentCardUpgrade?.agreementContent || "agreement",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TermUpgrade;
